module.exports = __webpack_public_path__ + "assets/img/solution1.f4367b54.png";